export const TRACKING_REFRESH_RATE: number = 25000; // 25 s
export const TIME_FOR_SESSION_STOP: number = 90000; // 1 min 30 s
export const SAVE_SESSION_RATE: number = 300000; // 5 min
export const MINIMUM_SESSION_TIME: number = 120;
export const TRACKED_EVENTS = ['mousemove', 'mousedown', 'keydown', 'touchstart'];
export const TRACKED_PAGES = ['Player', 'Player Class', 'Player School', 'Song'];
